import { createFileRoute } from '@tanstack/react-router'
import SettingsServiceAccountDetailPage from '@/components/pages/Settings/team/SettingsServiceAccountDetailPage/SettingsServiceAccountDetailPage'

export const Route = createFileRoute(
  '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName',
)({
  component: ServiceAccountDetailRoute,
})

function ServiceAccountDetailRoute() {
  return <SettingsServiceAccountDetailPage />
}
